"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var lodash_1 = require("lodash");
var accordion_1 = __importDefault(require("relements/build/esm/ui/accordion"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var radio_1 = __importDefault(require("relements/build/esm/input/radio"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
var api_1 = require("../store/api");
var Label_1 = __importDefault(require("./Label"));
var StyledComponets_1 = require("./StyledComponets");
var utils_1 = require("../utils");
var maps_1 = require("../maps");
var MetaAlgoliaMapping_1 = __importDefault(require("./MetaAlgoliaMapping"));
var CATALOG_SYNC_OPTIONS = [
    { title: 'Manual', value: 'manual', placeholder: 'Manual' },
    {
        title: 'Meta Catalog',
        value: 'meta_catalog',
        placeholder: 'Meta Catalog',
    },
];
var SYNC_STATUS = {
    in_progress: 'In Progress',
    completed: 'Completed',
    failed: 'Failed',
};
var CatalogSync = function (_a) {
    var _b, _c;
    var source = _a.source, onSourceChange = _a.onSourceChange, indexName = _a.indexName, onIndexNameChange = _a.onIndexNameChange, appName = _a.appName, catalogId = _a.catalogId, onCatalogIdChange = _a.onCatalogIdChange, syncFrequency = _a.syncFrequency, onSyncFrequencyChange = _a.onSyncFrequencyChange, lastSyncStatus = _a.lastSyncStatus, onSyncStatusChange = _a.onSyncStatusChange, lastSyncAt = _a.lastSyncAt, totalProductsSynced = _a.totalProductsSynced, active = _a.active, setAccordionActive = _a.setAccordionActive, isEdited = _a.isEdited, setIsEdited = _a.setIsEdited, onSave = _a.onSave, actionData = _a.actionData, setActionData = _a.setActionData, tempCatalogSyncData = _a.tempCatalogSyncData, setTempCatalogSyncData = _a.setTempCatalogSyncData;
    var _d = react_1.useState(false), isFetchingStatus = _d[0], setIsFetchingStatus = _d[1];
    var _e = react_1.useState(false), advancedSettingsModalActive = _e[0], setAdvancedSettingsModalActive = _e[1];
    var _f = react_1.useState(false), isCatalogIdEdited = _f[0], setIsCatalogIdEdited = _f[1];
    var _g = react_redux_1.useSelector(maps_1.stateToProps), errors = _g.errors, currentActionData = _g.currentActionData;
    var setErrors = maps_1.dispatchToProps(react_redux_1.useDispatch()).setErrors;
    var lastSyncTime = utils_1.formatTimestamp(lastSyncAt);
    var fetchSyncStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsFetchingStatus(true);
                    return [4 /*yield*/, api_1.getSyncCatalogStatus(currentActionData.id)];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    if (success) {
                        onSyncStatusChange(response.body);
                        setIsFetchingStatus(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var syncCatalogToIndex = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, api_1.syncCatalog(currentActionData.id, {
                        meta_catalog_id: catalogId,
                    })];
                case 1:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    if (success) {
                        onSyncStatusChange({ last_sync_status: response.body.status });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onSync = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isEdited) return [3 /*break*/, 2];
                    return [4 /*yield*/, onSave(actionData, function () {
                            setIsEdited(false);
                            syncCatalogToIndex();
                        })];
                case 1:
                    _a.sent();
                    setTempCatalogSyncData({});
                    return [3 /*break*/, 3];
                case 2:
                    syncCatalogToIndex();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var validateCatalogId = react_1.useCallback(lodash_1.debounce(function (catalogIdValue) { return __awaiter(void 0, void 0, void 0, function () {
        var META_TOKEN, response, data, error_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!catalogIdValue) {
                        setErrors(__assign(__assign({}, errors), { actionErrors: __assign(__assign({}, ((_a = errors.actionErrors) !== null && _a !== void 0 ? _a : {})), { catalogIdError: '' }) }));
                        return [2 /*return*/];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 5]);
                    META_TOKEN = process.env.META_ACCESS_TOKEN;
                    return [4 /*yield*/, fetch("https://graph.facebook.com/v18.0/" + catalogIdValue + "/products?access_token=" + META_TOKEN + "&summary=1&limit=150")];
                case 2:
                    response = _e.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _e.sent();
                    if ((_b = data === null || data === void 0 ? void 0 : data.error) === null || _b === void 0 ? void 0 : _b.message) {
                        setErrors(__assign(__assign({}, errors), { actionErrors: __assign(__assign({}, ((_c = errors.actionErrors) !== null && _c !== void 0 ? _c : {})), { catalogIdError: 'Please enter valid Catalog Id' }) }));
                    }
                    else {
                        setErrors(__assign(__assign({}, errors), { actionErrors: __assign(__assign({}, ((_d = errors.actionErrors) !== null && _d !== void 0 ? _d : {})), { catalogIdError: '' }) }));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _e.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, 300), []);
    var onAdvancedSettingsChange = function (val) {
        var _a, _b;
        setActionData(__assign(__assign({}, actionData), { action_details: __assign(__assign({}, actionData.action_details), { '4': __assign(__assign({}, ((_b = (_a = actionData.action_details) === null || _a === void 0 ? void 0 : _a['4']) !== null && _b !== void 0 ? _b : {})), { algolia_mapping_json: val }) }) }));
        setIsEdited(true);
    };
    var renderHeader = function (_a) {
        var ExpandIcon = _a.ExpandIcon;
        return (react_1["default"].createElement(box_1["default"], { color: "black.haptik", padding: "8px 16px", justifyContent: "space-between", marginBottom: "2px", alignItems: "center" },
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Catalog Settings"),
            react_1["default"].createElement(ExpandIcon, null)));
    };
    return (react_1["default"].createElement(accordion_1["default"], null,
        react_1["default"].createElement(StyledComponets_1.StyledAccordionItem, { active: active, onChange: function () {
                if (active) {
                    setAccordionActive('');
                    setAdvancedSettingsModalActive(false);
                }
                else {
                    setAccordionActive('catalogSync');
                }
            }, renderHeader: renderHeader },
            react_1["default"].createElement(box_1["default"], { padding: "8px", justifyContent: "space-between" },
                react_1["default"].createElement(radio_1["default"], { themed: true, variant: "primary", value: CATALOG_SYNC_OPTIONS.find(function (option) { return option.title === source; }), options: CATALOG_SYNC_OPTIONS, optionKey: "title", onChange: function (val) {
                        BotActions_1.showConfirmationDialog({
                            okTitle: 'Switch',
                            cancelTitle: 'Cancel',
                            title: 'Are you sure you want to change the Catalog sync settings?',
                            message: val.title.trim() === 'Meta Catalog'
                                ? 'Switching from Manual to Meta Catalog will disconnect your bot from the current catalog.'
                                : 'Switching from Meta Catalog to Manual will stop the automatic sync from your Meta Catalog.',
                            onOk: function () {
                                var _a, _b, _c, _d;
                                if (val.title.trim() === 'Manual') {
                                    setTempCatalogSyncData({
                                        meta_catalog_id: catalogId,
                                        sync_frequency: syncFrequency,
                                        index_name: indexName,
                                        last_sync_status: lastSyncStatus,
                                        last_sync_completed_at: lastSyncAt,
                                        total_products_completed: totalProductsSynced,
                                    });
                                    setActionData(__assign(__assign({}, actionData), { action_details: __assign(__assign({}, actionData.action_details), { '4': __assign(__assign(__assign({}, ((_b = (_a = actionData.action_details) === null || _a === void 0 ? void 0 : _a['4']) !== null && _b !== void 0 ? _b : {})), { source: val.title.trim(), meta_catalog_id: '', sync_frequency: '', index_name: '', last_sync_status: '', last_sync_completed_at: '', total_products_completed: 0 }), tempCatalogSyncData) }) }));
                                }
                                else {
                                    setActionData(__assign(__assign({}, actionData), { action_details: __assign(__assign({}, actionData.action_details), { '4': __assign(__assign(__assign({}, ((_d = (_c = actionData.action_details) === null || _c === void 0 ? void 0 : _c['4']) !== null && _d !== void 0 ? _d : {})), { source: val.title.trim() }), tempCatalogSyncData) }) }));
                                    setTempCatalogSyncData({
                                        index_name: indexName,
                                    });
                                }
                                setIsEdited(true);
                            },
                            onCancel: function () { },
                            okActionType: 'danger',
                        });
                    } }),
                lastSyncStatus === 'in_progress' && (react_1["default"].createElement(StyledComponets_1.ReloadWrapper, { onClick: fetchSyncStatus },
                    react_1["default"].createElement(StyledComponets_1.ReloadIconWrapper, { className: isFetchingStatus ? 'animate' : '', size: "small", tooltip: "Refresh catalog sync data" })))),
            react_1["default"].createElement(box_1["default"], { padding: "0 16px", flexDirection: "column", marginBottom: "16px" },
                source === 'Manual' && (react_1["default"].createElement(box_1["default"], { padding: " 0", flexDirection: "column" },
                    react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Catalog Sync Set up a new index in Algolia and add your catalog manually."),
                    react_1["default"].createElement(StyledComponets_1.StyledTextInput, { error: (_b = errors.actionErrors) === null || _b === void 0 ? void 0 : _b.indexNameError, onChange: onIndexNameChange, value: indexName, themed: true, placeholder: "Enter Index Name", label: react_1["default"].createElement(Label_1["default"], { info: "Choose the action that needs to be performed.", text: "Index Name" }), marginTop: "16px", marginBottom: "4px" }),
                    appName && (react_1["default"].createElement(box_1["default"], { padding: "0", margin: "8px 0 4px", justifyContent: "space-between" },
                        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Algolia App Name"),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, appName || '-'))))),
                source === 'Meta Catalog' && (react_1["default"].createElement(react_1["default"].Fragment, null,
                    react_1["default"].createElement(StyledComponets_1.StyledTextInput, { error: (_c = errors.actionErrors) === null || _c === void 0 ? void 0 : _c.catalogIdError, onChange: function (value) {
                            onCatalogIdChange(value);
                            validateCatalogId(value);
                            setIsCatalogIdEdited(true);
                        }, value: catalogId, themed: true, placeholder: "Enter Catalog Id", label: react_1["default"].createElement(Label_1["default"], { text: "Catalog Id", info: "Enter Meta Catalog Id" }) }),
                    react_1["default"].createElement(box_1["default"], { padding: 0, m: "16px 0" },
                        react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "Sync Frequency", label: react_1["default"].createElement(Label_1["default"], { info: "Select the frequency of the catalog sync process", text: "Sync Frequency" }), options: ['One Time', '1 hour', '24 hours'], value: syncFrequency || '', onChange: onSyncFrequencyChange })),
                    react_1["default"].createElement(box_1["default"], { padding: "0", style: { margin: '0 0 16px auto', gap: '8px' } },
                        react_1["default"].createElement(button_1["default"], { themed: true, variant: isCatalogIdEdited ? 'disabled' : 'primary', style: { margin: '0' }, onClick: function () {
                                setAdvancedSettingsModalActive(true);
                            }, disabled: isCatalogIdEdited || !catalogId }, "Advanced Settings"),
                        lastSyncStatus !== 'in_progress' &&
                            (catalogId ? (react_1["default"].createElement(button_1["default"], { themed: true, variant: "primary", style: { margin: '0' }, onClick: onSync }, "Sync Now")) : (react_1["default"].createElement(box_1["default"], { padding: "0" },
                                react_1["default"].createElement(tooltip_1["default"], { themed: true, position: "TOP", tooltip: "Please enter Catalog Id" },
                                    react_1["default"].createElement(button_1["default"], { themed: true, variant: "disabled", style: { margin: '0' } }, "Sync Now")))))),
                    lastSyncStatus && (react_1["default"].createElement(box_1["default"], { padding: "0", mb: "16px", justifyContent: "space-between" },
                        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Last Sync Status"),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, isFetchingStatus ? (react_1["default"].createElement(loader_1["default"], { size: "20px" })) : (SYNC_STATUS[lastSyncStatus] || '-')))),
                    lastSyncStatus === 'in_progress' && (react_1["default"].createElement(StyledComponets_1.LoadingBarContainer, null,
                        react_1["default"].createElement(StyledComponets_1.AnimatedBar, null))),
                    lastSyncStatus && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        lastSyncTime && (react_1["default"].createElement(box_1["default"], { padding: "0", mb: "16px", justifyContent: "space-between" },
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Last Sync At"),
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, lastSyncTime || '-'))),
                        totalProductsSynced && (react_1["default"].createElement(box_1["default"], { padding: "0", mb: "16px", justifyContent: "space-between" },
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Total Products Synced"),
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, totalProductsSynced || '-'))),
                        indexName && (react_1["default"].createElement(box_1["default"], { padding: "0", mb: "4px", justifyContent: "space-between" },
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Algolia Index Name"),
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, indexName || '-'))),
                        appName && (react_1["default"].createElement(box_1["default"], { padding: "0", mb: "4px", justifyContent: "space-between" },
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "Algolia App Name"),
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, appName || '-'))))),
                    react_1["default"].createElement(MetaAlgoliaMapping_1["default"], { active: advancedSettingsModalActive, closeModal: function () {
                            setAdvancedSettingsModalActive(false);
                        }, actionData: actionData, onAdvancedSettingsChange: onAdvancedSettingsChange })))))));
};
exports["default"] = CatalogSync;
